import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import LinearProgress from "@mui/material/LinearProgress";

const subscriptionOption = [
    { value: 1, label: "Active" },
    { value: 2, label: "In-active" },
];

const AddSubscription = ({ showModal, handleClose, fetchAllSubscription }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        sub_name: "",
        sub_status: "",
        sub_month: "",
        sub_amount: "",
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
    };

    const basicSchema = Yup.object().shape({
        sub_name: Yup.string()
            .min(3, "Subscription Name must be at least 3 characters.")
            .max(250, "Subscription Name must be at most 100 characters.")
            .matches(/^[a-zA-Z][a-zA-Z\s]*[a-zA-Z]$/, "Subscription Name should only contain letters and spaces, and should not start or end with a space.")
            .required("Subscription Name is required.")
            .test("unique-link", "Subscription Name is already existing in the database", async function (value) {
                if (!value) return true;
                const isSubscriptionNameUnique = await checkSubscriptionName(value);
                return isSubscriptionNameUnique;
            }),

        sub_status: Yup.string().required("Subscription Status is required."),
        // sub_status: Yup.string()
        //     .min(3, "Subscription Status must be at least 3 characters.")
        //     .max(250, "Subscription Status must be at most 100 characters.")
        //     .matches(/^[a-zA-Z\s]*$/, "Subscription Status can only contain letters.")
        //     .required("Subscription Status is required.")
        //     .strict(),
        sub_month: Yup.number()
            .required("Month is required.")
            .positive("Month must be a positive number.")
            .min(1, "Month must be at least 1.")
            .max(12, "Month must be at most 12.")
            .typeError("Month must be a number."),

        sub_amount: Yup.number()
            .required("Amount is required.")
            .positive("Amount must be a positive number.")
            .min(0.01, "Amount must be at least $0.01.")
            .typeError("Amount must be a number."),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addSubscription",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllSubscription();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    async function checkSubscriptionName(sub_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkSubscriptionName",
            sub_name: sub_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const today = new Date().toISOString().split("T")[0];
    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={formik.handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Name <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="sub_name"
                                placeholder="Enter subscription name"
                                value={formik.values.sub_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.sub_name && formik.errors.sub_name}
                            />
                            {formik.errors.sub_name && formik.touched.sub_name && (
                                <Form.Control.Feedback type="invalid">{formik.errors.sub_name}</Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Status <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            {/* <Form.Control
                                type="text"
                                name="sub_status"
                                value={formik.values.sub_status}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.sub_status && formik.errors.sub_status}
                            /> */}
                            <Select
                                options={subscriptionOption}
                                id="sub_status"
                                name="sub_status"
                                value={subscriptionOption.filter((option) => values.sub_status == option.value)}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "sub_status",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, sub_status: true });
                                }}
                            />
                            {errors.sub_status && touched.sub_status && (
                                <p className="text-danger" style={{ fontSize: "0.70rem" }}>
                                    {errors.sub_status}
                                </p>
                            )}
                            {/* {formik.errors.sub_status && formik.touched.sub_status && (
                                <Form.Control.Feedback type="invalid">{formik.errors.sub_status}</Form.Control.Feedback>
                            )} */}
                            {/* {errors.sub_status && touched.sub_status && <Form.Control.Feedback type="invalid">{errors.sub_status}</Form.Control.Feedback>} */}
                            {/* {errors.sub_status && touched.sub_status && <p className="text-danger">{errors.sub_status}</p>} */}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Month <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="sub_month"
                                placeholder="Enter subscription month"
                                value={formik.values.sub_month}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.sub_month && formik.errors.sub_month}
                            />
                            {formik.errors.sub_month && formik.touched.sub_month && (
                                <Form.Control.Feedback type="invalid">{formik.errors.sub_month}</Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Amount <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="sub_amount"
                                placeholder="Enter subscription amount"
                                value={formik.values.sub_amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={formik.touched.sub_amount && formik.errors.sub_amount}
                            />
                            {formik.errors.sub_amount && formik.touched.sub_amount && (
                                <Form.Control.Feedback type="invalid">{formik.errors.sub_amount}</Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <Button variant="dark" type="submit" disabled={isSubmitting}>
                            Save
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddSubscription;
